const SWFT_DIGITAL_AUTH2_CLIENT_ID = process.env.REACT_APP_AUTH2_CLIENT_ID;
const SWFT_DIGITAL_API_HOST = process.env.REACT_APP_API_HOST;
const GOOGLE_OAUTH_CLIENT_ID = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID;
const DEFAULT_IMG_HOST = process.env.REACT_APP_DEFAULT_IMG_HOST;

export {SWFT_DIGITAL_AUTH2_CLIENT_ID, SWFT_DIGITAL_API_HOST, GOOGLE_OAUTH_CLIENT_ID, DEFAULT_IMG_HOST};
